import { EventEmitter, enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
//import { environment } from './environments/environment';
import { first } from 'rxjs';
import { ConfigurationService } from './app/Configuration.service';
import { environment } from './app/environment';


(async () => {
  try {
    let platformRef = await platformBrowserDynamic();
    let configService = new ConfigurationService();
    configService.fetchEnvironment();

    let environments = await configService.environment$.pipe(first()).toPromise();
   let configs= await configService.fetchConfiguration(environments?.Environment);


    //let configs = await configService.configs$.pipe(first()).toPromise();
    configService.mapConfigurationSettings(configs);

    // DYNAMIC IMPORT HERE
    import('./app/app.module').then(module => {
      bootstrap(module.AppModule);
    });

    if (configs?.production) {
      enableProdMode();
    }
    // platformRef.bootstrapModule(AppModule);
  } catch (error) {
    console.error("Initializing error", error);
  }
})();



function bootstrap(AppModules: any) {
  /*if (config.production) {
    enableProdMode();
  }*/

  platformBrowserDynamic().bootstrapModule(AppModules).then(ref => {
    //Ensure Angular destroys itself on hot reloads.
    let aa = window;
    // if (window['ngRef']) {
    //   window['ngRef'].destroy();
    // }
    // window['ngRef'] = ref;

    // Otherwise, log the boot error
  }).catch(err => console.error(err));
}


// if (environment.production) {
//   enableProdMode();
// }

// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));
